import { useState, useEffect } from "react";
import axios from "axios";
import { Navigate, useNavigate } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const WITH_CREDS = { withCredentials: true };

export default function AdminLogin() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [err, setErr] = useState("");
    const [loading, setLoading] = useState(false);
    const nav = useNavigate();

    useEffect(() => {
        // If a valid httpOnly session cookie exists, go straight to the dashboard.
        let alive = true;
        axios.get(`${API}/admin/me`, WITH_CREDS)
            .then(() => { if (alive) nav("/admin", { replace: true }); })
            .catch(() => { /* not logged in — stay on the login page */ });
        return () => { alive = false; };
    }, [nav]);

    const submit = async (e) => {
        e.preventDefault();
        setErr("");
        setLoading(true);
        try {
            await axios.post(`${API}/admin/login`, { email, password }, WITH_CREDS);
            nav("/admin", { replace: true });
        } catch (ex) {
            const detail = ex?.response?.data?.detail || "Errore di rete.";
            setErr(typeof detail === "string" ? detail : "Credenziali non valide.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ minHeight: "100vh", background: "var(--itly-cream)", display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }}>
            <form onSubmit={submit} className="itly-card" data-testid="admin-login-form" style={{ width: "100%", maxWidth: 420, padding: "36px 34px" }} noValidate>
                <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 24 }}>
                    <img src="/assets/itly/logo-turista.png" alt="ITLY" style={{ width: 40, height: 40, borderRadius: 10, background: "#8BAFC7" }} />
                    <span className="itly-wordmark">ITLY <span style={{ color: "var(--itly-muted)", fontWeight: 500 }}>Admin</span></span>
                </div>
                <h1 className="itly-serif" style={{ margin: 0, fontSize: 30, color: "var(--itly-teal-900)", letterSpacing: "-0.02em" }}>
                    Accedi.
                </h1>
                <p style={{ margin: "8px 0 24px", fontFamily: "Inter, sans-serif", fontSize: 14, color: "var(--itly-muted)" }}>
                    Dashboard riservata alle registrazioni ITLY.
                </p>

                <label style={{ display: "block", marginBottom: 14 }}>
                    <span style={{ display: "block", fontFamily: "Inter, sans-serif", fontSize: 13, fontWeight: 600, color: "var(--itly-teal-900)", marginBottom: 6 }}>Email</span>
                    <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="admin-email" className="itly-input" placeholder="admin@…" />
                </label>
                <label style={{ display: "block", marginBottom: 18 }}>
                    <span style={{ display: "block", fontFamily: "Inter, sans-serif", fontSize: 13, fontWeight: 600, color: "var(--itly-teal-900)", marginBottom: 6 }}>Password</span>
                    <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="admin-password" className="itly-input" placeholder="••••••••" />
                </label>

                {err && (
                    <div data-testid="admin-login-error" style={{ padding: "10px 12px", borderRadius: 10, background: "#FDEEE7", color: "var(--itly-orange-700)", border: "1px solid rgba(198, 90, 56, 0.25)", fontFamily: "Inter, sans-serif", fontSize: 13.5, marginBottom: 14 }}>{err}</div>
                )}

                <button type="submit" disabled={loading} data-testid="admin-login-submit" className="itly-btn-primary" style={{ width: "100%", justifyContent: "center", opacity: loading ? 0.6 : 1 }}>
                    {loading ? "Accesso..." : "Entra"}
                </button>
            </form>
        </div>
    );
}

export function RequireAdmin({ children }) {
    // httpOnly cookie can't be read by JS: validate the session server-side.
    const [status, setStatus] = useState("checking"); // checking | ok | fail
    useEffect(() => {
        let alive = true;
        axios.get(`${API}/admin/me`, WITH_CREDS)
            .then(() => { if (alive) setStatus("ok"); })
            .catch(() => { if (alive) setStatus("fail"); });
        return () => { alive = false; };
    }, []);
    if (status === "checking") {
        return (
            <div data-testid="admin-auth-checking" style={{ minHeight: "100vh", background: "var(--itly-cream)", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "Inter, sans-serif", color: "var(--itly-muted)" }}>
                Verifica sessione…
            </div>
        );
    }
    if (status === "fail") return <Navigate to="/admin/login" replace />;
    return children;
}
